import { Button } from 'components/atom/Button'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import API from 'service/api'
import {
  isTikTokLoggedIn,
  removeTikTokToken,
  saveTikTokToken,
} from 'service/tiktok'

export const UploadTiktokBtn = () => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const [tokenData, setTokenData] = useState<{
    access_token?: string
    refresh_token?: string
    expires_in?: number
  } | null>(null)

  useEffect(() => {
    const handleAuthCallback = () => {
      const urlParams = new URLSearchParams(window.location.search)
      const accessToken = urlParams.get('access_token')
      const refreshToken = urlParams.get('refresh_token')
      const expiresIn = urlParams.get('expires_in')

      if (accessToken && refreshToken && expiresIn) {
        const tokenInfo = {
          access_token: accessToken,
          refresh_token: refreshToken,
          expires_in: parseInt(expiresIn),
        }
        setTokenData(tokenInfo)
        localStorage.setItem('tiktok_token', JSON.stringify(tokenInfo))
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        )
      }
    }

    if (
      window.location.pathname === '/success' ||
      window.location.search.includes('access_token')
    ) {
      handleAuthCallback()
    }

    if (isTikTokLoggedIn()) {
      const savedToken = localStorage.getItem('tiktok_token')
      if (savedToken) {
        try {
          setTokenData(JSON.parse(savedToken))
        } catch (error) {
          removeTikTokToken()
          localStorage.removeItem('tiktok_token')
        }
      }
    }
  }, [])

  const handleTiktokLogin = async () => {
    setIsLoading(true)
    try {
      const response = await API.get('/auth/tiktok/login')
      const { authUrl } = response.data || response

      const popup = window.open(
        authUrl,
        'tiktokAuth',
        'width=500,height=600,scrollbars=yes,resizable=yes'
      )

      const checkClosed = setInterval(() => {
        if (popup?.closed) {
          clearInterval(checkClosed)
          setIsLoading(false)
        }
      }, 1000)

      const messageHandler = (event: MessageEvent) => {
        if (event.origin !== window.location.origin) return

        if (event.data.type === 'TIKTOK_AUTH_SUCCESS') {
          const { tokenData: tokens } = event.data
          setTokenData(tokens)
          localStorage.setItem('tiktok_token', JSON.stringify(tokens))
          saveTikTokToken(tokens.access_token)
          popup?.close()
          clearInterval(checkClosed)
          setIsLoading(false)
          window.removeEventListener('message', messageHandler)
        }
      }

      window.addEventListener('message', messageHandler)
    } catch (error) {
      alert(t('tiktok.messages.loginFailed') + (error as Error).message)
      setIsLoading(false)
    }
  }

  const handleUpload = async () => {
    if (!tokenData?.access_token) {
      alert(t('tiktok.messages.loginFirst'))
      return
    }
    try {
      setIsLoading(true)
      const result = await API.post('/tiktok/upload', { ...tokenData })

      console.log('✅ TikTok API 성공:', {
        status: result.status,
        statusText: result.statusText,
        data: result.data,
        headers: result.headers,
      })

      alert('TikTok Upload Success!')
    } catch (error: any) {
      console.log('❌ TikTok API 실패:', {
        message: error.message,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        config: error.config,
        isAxiosError: error.isAxiosError,
      })

      alert(
        'TikTok Upload Fail!: ' +
          (error.response?.data?.error_description || error.message)
      )
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <button
      onClick={() => {
        if (tokenData) {
          handleUpload() // 로그인되어 있으면 업로드 실행
        } else {
          handleTiktokLogin() // 로그인 안되어 있으면 로그인
        }
      }}
      disabled={isLoading}
    >
      <img
        src="https://i.namu.wiki/i/B0eFTRRR2y0QBMsk6yDSEjmNEUB78rsZ0k415BRtahQmVAORx7dMJE9ZB4IydX_z1Fjt-xiHQCKHLWGPOtCd_I6MID3remffmjt9ER8rV13TQNqq3onKJ1MywNVImKPkURQbyKptyHmbyURQ8HAvDw.svg"
        alt=""
        width={40}
        height={40}
        className=" active:scale-95 1"
      />
    </button>
  )
}
